var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_146)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.7637 7.33333L6.66663 16.3333H26.6666L16.7637 25.3333",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.6667C18.5076 10.6667 20 9.17428 20 7.33333C20 5.49239 18.5076 4 16.6666 4C14.8257 4 13.3333 5.49239 13.3333 7.33333C13.3333 9.17428 14.8257 10.6667 16.6666 10.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.6667C18.5076 10.6667 20 9.17428 20 7.33333C20 5.49239 18.5076 4 16.6666 4C14.8257 4 13.3333 5.49239 13.3333 7.33333C13.3333 9.17428 14.8257 10.6667 16.6666 10.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 19.3333C8.50759 19.3333 9.99998 17.8409 9.99998 16C9.99998 14.1591 8.50759 12.6667 6.66665 12.6667C4.8257 12.6667 3.33331 14.1591 3.33331 16C3.33331 17.8409 4.8257 19.3333 6.66665 19.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 19.3333C8.50759 19.3333 9.99998 17.8409 9.99998 16C9.99998 14.1591 8.50759 12.6667 6.66665 12.6667C4.8257 12.6667 3.33331 14.1591 3.33331 16C3.33331 17.8409 4.8257 19.3333 6.66665 19.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 28C18.5076 28 20 26.5076 20 24.6667C20 22.8257 18.5076 21.3333 16.6666 21.3333C14.8257 21.3333 13.3333 22.8257 13.3333 24.6667C13.3333 26.5076 14.8257 28 16.6666 28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 28C18.5076 28 20 26.5076 20 24.6667C20 22.8257 18.5076 21.3333 16.6666 21.3333C14.8257 21.3333 13.3333 22.8257 13.3333 24.6667C13.3333 26.5076 14.8257 28 16.6666 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.3333C27.8409 19.3333 29.3333 17.8409 29.3333 16C29.3333 14.1591 27.8409 12.6667 26 12.6667C24.159 12.6667 22.6666 14.1591 22.6666 16C22.6666 17.8409 24.159 19.3333 26 19.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.3333C27.8409 19.3333 29.3333 17.8409 29.3333 16C29.3333 14.1591 27.8409 12.6667 26 12.6667C24.159 12.6667 22.6666 14.1591 22.6666 16C22.6666 17.8409 24.159 19.3333 26 19.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(3.33331 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyn);
export default __webpack_public_path__ + "static/media/SYN.bf962dc23bbfdc3160a2bf9f92b4d103.svg";
export { ForwardRef as ReactComponent };